import { render, staticRenderFns } from "./ResubmitDialog.vue?vue&type=template&id=371c48d6&scoped=true"
import script from "./ResubmitDialog.vue?vue&type=script&lang=js"
export * from "./ResubmitDialog.vue?vue&type=script&lang=js"
import style0 from "./ResubmitDialog.vue?vue&type=style&index=0&id=371c48d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371c48d6",
  null
  
)

export default component.exports